/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-12-11 19:37:11
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2023-02-21 17:43:10
 * @FilePath: \gismanger\src\network\axios.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import Qs from 'qs'; // 用来处理参数，可不使用，若要使用，npm安装： npm install qs
axios.defaults.baseURL = 'https://www.moodsci.com/pigbox'; // 请求的默认域名
// axios.defaults.baseURL = '/api'; // 请求的默认域名
// 添加一个请求拦截器


axios.interceptors.request.use(config => {
    config.headers.languagetype = 'CN'; // 举例，加上一个公共头部
    config.data = Qs.stringify(config.data); // 处理数据，可不写
    return config;
},
    err => {
        return Promise.reject(err);
    });
//添加一个响应拦截器
axios.interceptors.response.use(res => {
    //在这里对返回的数据进行处理

    console.log(res.data, '网络正常');
    return res.data;
}, err => {
    console.log('网络开了小差！请重试...');
    return Promise.reject(err);
})

export default axios

